<template>
    <div>
        <v-breadcrumbs :items="crumbs" divider="/" style="background-color: #f0f0f0">
        </v-breadcrumbs>
        <v-card class="mx-auto" outlined tile color="#F8F8FF">
        <v-card-title>WhatsApp</v-card-title>
        <v-container class="fill-height"
        fluid>
            <v-row>
                <v-btn-toggle class="col-12 col-md-6 offset-md-6" style="background: none">
                    <v-btn small disabled>
                        <v-icon small>fa fa-search</v-icon>
                    </v-btn>
                    <v-text-field placeholder="Search" class="search-textfield" hide-details outlined dense v-model="search"></v-text-field>
                </v-btn-toggle>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-pagination
                    v-model="page"
                    :length.sync="pages"
                    :total-visible="6"
                    class="mt-4"
                    style="float: left !important"
                    ></v-pagination><br/><p class="text-caption" style="margin-left: 10px">Page {{page}} of {{pages}}</p>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col><span class="text-body-2">View {{page > 1 ? (page - 1) * 100 + 1 : 1}} - {{getCount}} of {{totalrecords}}</span></v-col>
                <v-col cols="12" md="12">
                    <v-overlay
                    :absolute="true"
                    :value="overlay"
                    >
                        <v-progress-circular
                    indeterminate
                    color="primary"
                    ></v-progress-circular>
                    </v-overlay>
                    <v-data-table
                        calculate-widths
                        :headers="headers"
                        :items="items"
                        hide-default-footer
                        :loading="tableloading"
                        loading-text= "Loading Data... Please wait"
                        :items-per-page="100"
                        id="main-table"
                        sort-by="CreatedDateTime"
                        dense
                    >
                    <template slot="item" slot-scope="props">
                        <tr>
                            <td>{{page > 1 ? (page - 1) * 100 + props.index + 1 : props.index + 1}}</td>
                            <td>
                                <v-tooltip top v-if="validateAccess('whatsapp_viewdetails')">
                                <template v-slot:activator="{ on }">
                                    <a v-on="on" style="text-decoration: underline" id="custom-hover" @click.prevent="viewMore(props.item, 'view')">{{props.item.ID}}</a>
                                </template>
                                <span>View</span>
                                </v-tooltip>
                                <span v-else>{{props.item.ID}}</span>
                            </td>
                            <td>{{props.item.phoneNumber}}</td>
                            <td>{{props.item.templateID}}</td>
                            <td>{{props.item.templateName}}</td>
                            <td>{{props.item.createdDate}}</td>
                            <td>{{props.item.statusName}}</td>
                            <td v-if="validateAccess('whatsapp_chat') || validateAccess('whatsapp_viewdetails')">
                                <v-tooltip top v-if="validateAccess('whatsapp_chat')">
                                <template v-slot:activator="{ on }">
                                    <a v-on="on" style="text-decoration: underline" id="custom-hover" @click.prevent="viewMore(props.item, 'chat')">{{props.item.chat}}</a>
                                </template>
                                <span>Chat with Customer</span>
                                </v-tooltip>
                                <v-tooltip top v-else>
                                <template v-slot:activator="{ on }">
                                    <a v-on="on" style="text-decoration: underline" id="custom-hover" @click.prevent="viewMore(props.item, 'view chat')">{{props.item.chat}}</a>
                                </template>
                                <span>View Chat History</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        </v-card>
        <v-snackbar
        v-model="swal.notification"
        top
        :color="swal.scolor"
        >
            {{ swal.message }}
        </v-snackbar>
        <create :dialog="ma.modal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :allInfo="ma.allInfo" @confirm="onConfirm" @closed="onClosed"></create>
        <edit :dialog="ma.modal_update" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :readonly="ma.readonly" :allInfo="ma.allInfo" @delete="onDelete" @confirm="onConfirm" @closed="onClosed"></edit>
        <chat :dialog="ma.modal_chat" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :readonly="ma.readonly" :allInfo="ma.allInfo" @delete="onDelete" @confirm="onConfirm" @closed="onClosed"></chat>
        <alert :dialog="ma.modal_status" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alert>
        <alertbox2 :dialog="ex.modal" @closed="onClosed" :content="ex.content"></alertbox2>
    </div>
</template>
<script>
import timer from '../../assets/js/sleeper';
import create from '.././modals/CreateWhatsAppMessageTemplate';
import edit from '.././modals/UpdateWhatsApp';
import chat from '.././modals/ChatWhatsApp';
import alert from '.././modals/Alert';
import {ERR} from '../../assets/js/errhandle.js';
import alertbox2 from '../modals/Notification';
import * as moment from "moment";
import * as tz from "moment-timezone";
import {rule} from '../../assets/js/checkPerm';

export default {
    name: 'WhatsApp',
    title: 'WhatsApp',
    
    data()  {
        return {
            crumbs: [
                {
                text: 'Home',
                disabled: true,
                href: '#',
                },

                {
                text: 'Message',
                disabled: true,
                href: '#',
                },

                {
                text: 'WhatsApp',
                disabled: true,
                href: '#',
                },

                {
                text: 'WhatsApp',
                disabled: true,
                href: '#',
                },
            ],
            items: [],
            search: '',
            headers: [
                { text: '#', value: 'row', width: '3%' },
                { text: 'ID', value: 'categoryid', width: '3%' },
                { text: 'Mobile No.', value: 'categoryname', width: '5%' },
                { text: 'Template ID', value: 'categoryname', width: '5%' },
                { text: 'Message Template Name', value: 'categoryname', width: '5%' },
                { text: 'Created Date', value: 'categorycreateddatetime', width: '10%', sort: function (a, b) {
                    let aa = moment(a, 'DD-MM-YYYY hh:mm:ss A');
                    let aa2 = aa.toDate();

                    let bb = moment(b, 'DD-MM-YYYY hh:mm:ss A');
                    let bb2 = bb.toDate();

                    return aa2 > bb2 ? -1 : aa2 < bb2 ? 1 : 0;
                }  },
                { text: 'Sent Status', value: 'categoryname', width: '5%' },
                { text: 'Chat', value: 'categoryname', width: '5%' },
            ],
            tableloading: false,
            btn_loading: false,
            pages: 0,
            page: 1,
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                confirmCreate: false,

                modal_status: false,
                modal_update: false,
                modal_chat: false,
                readonly: true,
                allInfo: [],
            },

            ex: {
                modal: false,
                content: {
                    headline: '',
                    icon: '',
                    chipColor: '',
                    iconColor: '',
                    maintext: '',
                    smalltext: ''
                }
            },

            category: {
                items: [],
                itemsFull: [],
                selected: '',
                loader: false,
                disable: false,
                rule: []
            },

            notificationisread: {
                items: [
                    {id: 'null', name: 'All'},
                    {id: '0', name: 'Not Read'},
                    {id: '1', name: 'Read'}
                ],
                itemsFull: [],
                selected: 'null',
                loader: false,
                disable: false,
                rule: []
            },

            services: [],
            totalrecords: '',
            overlay: false
        }
    },

    components: {create, edit, chat, alert, alertbox2},

    watch: {
        page: {
        handler: function(value) {
            this.items = [];
            this.listAll();
        }
        },

        'search': {
        handler: function(value) {
            this.searchTimeOut();
        }
        }
    },

    computed: {
        getCount(){
            if (this.items.length > 0)
                return this.items[this.items.length - 1].row;

            else{
                return '';
            }
        },
    },

    async created(){
        this.getHeaders();
        await this.listAll();
    },

    methods: {
        async listAll(pg){
            try{
                this.tableloading = true;
                let response = await this.$store.dispatch("getWhatsApp", {page: pg > 0 ? this.page = pg : this.page, search: this.search});

                let dt = response.data.record;
                
                let recordCount = response.data.recordcount;
                this.totalrecords = recordCount;

                if (response.data.code === 'AP000'){
                    if (this.$route.query.created == true){
                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Push Created!`;
                        this.$router.replace({'query': null});
                    }
                }

                for(var i=0; i<dt.length; i++){
                        dt[i].row = this.page > 1 ? (this.page - 1) * 100 + i + 1 : i + 1;
                        dt[i].phoneNumber = dt[i].phoneNumber || 'N/A';
                        dt[i].createdDate = dt[i].createdDate == null ? "N/A" : moment(dt[i].createdDate).format('DD-MM-YYYY hh:mm:ss A');
                        dt[i].chat = "Chat";
                }

                this.items = dt;
                this.pages = Math.ceil(recordCount / 100);
                this.tableloading = false;
                
            }

            catch(err){
                console.log(err);
            }
        },

        validateAccess(val){
            let access = JSON.parse(JSON.stringify(this.$store.getters.getAccess))
            return rule.checkaccess(val, access);
        },

        getHeaders(){
            if (this.validateAccess('whatsapp_viewdetails') || this.validateAccess('whatsapp_chat'))
                this.headers;

            else
                this.headers.splice(-1, 1);
        },

        async templateAdd(v){
            this.btn_loading = true;
            this.tableloading = true;
            try{
                this.swal.scolor = 'green';
                let req = {
                    TemplateName: v.TemplateName.item,
                    TemplateText: v.TemplateText.item,
                    PlaceholderCount: v.PlaceholderCount.item,
                };
                let response = await this.$store.dispatch("createMessageTemplate", req);
                if (response.data.code === 'AP000'){
                    await this.listAll();
                    this.swal.notification = true;
                    this.swal.scolor = 'green';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}: Message Template Created!`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
                this.btn_loading = false;
            }

            catch(err){
                this.swal.notification = true;
                this.swal.scolor = 'red';
                this.swal.message = ERR.HANDLE(response.data.code);
            }
        },

        async operatorRemove(){
            try{
                this.tableloading = true;
                let response = await this.$store.dispatch("deleteInbox", {notificationid: this.ma.modalInfo.notificationid})
                if (response.data.code === 'AP000'){
                        await this.listAll();

                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: This has has been removed!`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
            }

            catch(err){
                console.log(err);
                this.swal.scolor = 'red';
                this.swal.notification = true;
                this.swal.message = "Something went wrong. Please try again later";
                this.tableloading = false;
            }
        },

        async templateUpdate(v){
            let req = {
                ID: this.ma.modalInfo.ID,
                TemplateText: v.TemplateText.item,
                PlaceholderCount: v.PlaceholderCount.item,
                ApprovedByTwilio: v.ApprovedByTwilio.item
            };

            try{
                this.tableloading = true;
                let response = await this.$store.dispatch("updateMessageTemplate", req)
                if (response.data.code === 'AP000'){
                        await this.listAll();

                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Message Template has been updated!`;
                }

                else if (response.data.code === 'RD002'){
                        this.swal.notification = true;
                        this.swal.scolor = 'red';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Unable to update.`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
            }

            catch(err){
                this.swal.scolor = 'red';
                this.swal.notification = true;
                this.swal.message = "Something went wrong. Please try again later";
                this.tableloading = false;
            }
        },

        async viewMore(row, flag){
            //this.autoRefresh = 0;
            if (flag == 'delete'){
                this.ma.modal_status = true;
                this.ma.modalInfo = row;
            }

            if (flag == 'create'){
                this.ma.modal = true;
                this.ma.allInfo = this.items;
            }

            if (flag == 'chat'){
                this.ma.modal_chat = true;
                this.ma.readonly = false;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
            }

            if (flag == 'view chat'){
                this.ma.modal_chat = true;
                this.ma.readonly = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
            }

            if (flag == 'view' || flag == 'edit'){
                this.overlay = true;
                let response = await this.$store.dispatch("getWhatsAppByID", {ID: row.ID});
                this.overlay = false;
                let dt = response.data.record;
                dt.createdDate = dt.createdDate == null ? "N/A" : moment(dt.createdDate).format('DD-MM-YYYY hh:mm:ss A');
                dt.sentDate = dt.sentDate == null ? "N/A" : moment(dt.sentDate).format('DD-MM-YYYY hh:mm:ss A');
                dt.phoneNumber = dt.phoneNumber || "N/A";
                this.ma.modal_update = true;
                this.ma.modalInfo = dt;
                this.ma.allInfo = this.items;
                if (flag == 'edit') this.ma.readonly = false;
            }

            this.ma.customText = {text1: "Gate ID", text2: "Name"};
            this.ma.modal_action_type = flag;
        },

        viewProfile(row){
            this.ma.modalInfo = row;
            this.$router.push({ name: "Admin Profile", params: {id: row.userID}, query: {email: row.email}});
        },

        viewSOC(row){
            this.ma.modalInfo = row;
            this.$router.push({ name: "Admin SOC", params: {id: row.userID}, query: {email: row.email}});
        },

        onClosed(value){
            console.log(value)
            if (value == false){
                this.ma.modal = value;
                this.ma.modal_status = value;
                this.ma.modal_update = value;
                this.ma.modal_chat = value;
                this.ex.modal = value;
            }
        },

        onConfirm(value){
            console.log('aa', value)
            if (value.flag === 'create'){
                this.ma.confirmCreate = true;
                this.ma.modal = false;
                this.templateAdd(value);
            }

            if (value.flag === 'update'){
                this.ma.modal_update = false;
                this.templateUpdate(value);
            }
        },

        onDelete(){
            this.ma.modal_update = false;
            this.operatorRemove();
        },

        async execFilter(type){
            if (type == 'category'){
                await this.searchTimeOut();
            }

            if (type == 'isread'){
                await this.searchTimeOut();
            }
        },

        searchTimeOut() {

          clearTimeout(this.timeout);

          // Make a new timeout set to go off in 800ms
          this.timeout = setTimeout(() => {
          this.listAll();
          }, 800);
        },

        statusCheck(val){
            if (val === true){ return 'Approved'}
            else if (val === false){return 'Not Approve'}
            else {return 'null'}
        },

        mobileDisplayStatus(val, typ){
            if (typ == 'text'){
                    if (val === 1){ return 'Yes'}
                    else if (val === 0){return 'No'}
                    else {return 'null'}
            }

            if (typ == 'color'){
                    if (val === 1){ return 'green'}
                    else if (val === 0){return 'red'}
                    else {return 'grey'}
            }
        },
    }
}
</script>